<template>
	<page-promotion :to="to" :width="width"></page-promotion>
</template>
<script>
	import { ref, computed, watch, onMounted, inject } from "vue";
	import { useRouter } from "vue-router";
	import pagePromotion from "@/components/webComponents/widget/pagePromotion/pagePromotion.vue";
	export default {
		components: { pagePromotion },
		props: {
			to: {
				type: String,
				default: ""
			},
			width: {
				type: Number,
				default: 0
			}
		},
		setup(props, context) {
			return {};
		}
	};
</script>
<style lang="scss">
	//@import "@/assets/css/globalVars.scss";
</style>
<style lang="scss" scoped>
	@use "@/assets/css/globalVars.scss" as *;

	.content-container {
		display: flex;
		flex-direction: column;
		gap: $margin-element-small;
	}
</style>
